const base = {
    baseUrl: "",
    menus: "/api/manager/menu/menuList",
    userInfo: "/api/manager/info/my",
    loginCaptchaToken: "/login/captchaToken",
    login: "/open/login/accountLogin",
    logout: "/api/user/logout?channel=0",

    getOssKeySecret: "/api/manager/oss/getOssKeySecret",
    updateSystemConfig: '/api/manager/config/update',
    getSystemConfig: '/api/manager/config/getConfigValues?keys={0}',
    updateImageValue: '/api/manager/config/updateImageValue',
    getEnumOptionList: '/api/manager/enum/list4select/{0}?ordered={1}&refId={2}',
    deleteUser: '/api/manager/deleteUserById?id={0}',
    getUserMenu: '/user/info/menu',
    getDifficultySettings: '/manager/difficulty/setting/getSettings',
    updateSubjectSetting: '/manager/difficulty/setting/update',
    getEditorParams: '/api/manager/material/editorParams',
    getUser4select: '/api/manager/user/list4select',
    createMaterial: '/api/manager/material/create',
    listMaterial: '/api/manager/material/list',
    getMaterial4Edit: '/api/manager/material/getMaterial4Edit?id={0}',
    deleteMaterial: '/api/manager/material/delete?id={0}',
    downloadAsZipFile: '/api/manager/material/download?id={0}',
    getMaterial: '/api/manager/material/getMaterial?id={0}',
    createEnumValue: '/api/manager/enum/create',
    updateEnumValue: '/api/manager/enum/update',
    getEnumValueById: '/api/manager/enum/getById?id={0}',
    updateEnumValueEnableState: '/api/manager/enum/updateEnumValueEnableState?id={0}&value={1}',
    deleteDataStatistic: '/api/manager/material/deleteDataStatistic',
    updateAuthorCare: '/api/manager/xhs/author/changeCare?id={0}',
    updateAuthorUs: '/api/manager/xhs/author/changeUs?id={0}',
    getCareAuthorList: '/api/manager/xhs/author/getCareAuthorList',
    deleteAuthor: '/api/manager/xhs/author/delete?id={0}',
    getXhsNotes: '/api/manager/xhs/note/getXhsNotes',
    getNoteData: '/api/manager/xhs/note/getTrendData?noteId={0}',
    queryCareNoteUpdate: '/api/manager/xhs/note/queryCareNoteUpdate?after={0}',
    getSiteConfigList: '/api/manager/site/config/getSiteConfig?siteId={0}',
    createOrUpdateSiteConfig: '/api/manager/site/config/updateOrCreate',
    updateSitePageVisible: '/api/manager/site/page/setVisible',
    updateBannerEnableState: '/api/manager/site/banner/updateBannerEnableState?id={0}&value={1}',
    getSitePageById: '/api/manager/site/page/getById?pageId={0}',
    querySiteStyle: '/api/manager/site/page/querySiteStyle?htmlId={0}',
    getCareNoteUpdateSwitch: '/api/manager/xhs/note/getCareNoteUpdateSwitch',
    getPageVersions: '/api/manager/site/page/getPageHistory?htmlId={0}',
    markHtmlEditing: '/api/manager/site/page/editing',
    exportPageStatistic:'/api/manager/site/page/exportPageStatisticList?siteId={0}',
    revertDeletePage:'/api/manager/site/page/revertDelete?id={0}',
    getSiteCountDownList:'/api/manager/site/countdown/list?siteId={0}',
    deleteEnum:'/api/manager/enum/delete?id={0}',
    deleteCountdownDate:'/api/manager/site/countdown/delete?id={0}',
    deleteCountdownPage:'/api/manager/site/countdown/deletePage?dateId={0}&pageId={1}',
    addPageToCountDownDate:'/api/manager/site/countdown/addPageToDate',
    updateSchoolRecommendPage:'/api/manager/site/school/updateSchoolRecommendPage',


    queryForm: {
        1: '/api/manager/user/getQueryForm',
        2: '/api/manager/xhs/author/getQueryForm',
        3: '/api/manager/xhs/note/getQueryForm',
        4: '/api/manager/site/page/getQueryForm',
        5: '/api/manager/site/spy/getQueryForm',
        6: '/api/manager/site/page/getStatisticQueryForm',
        7: '/api/manager/site/school/getQueryForm',
        8: '/api/manager/enum/getQueryForm',
    },
    dialogs: {
        1: '/api/manager/enum/getCreateForm?type=BIZ_TYPE',
        2: '/api/manager/enum/getCreateForm?type=PLATFORM',
        3: '/api/manager/enum/getCreateForm?type=MATERIAL_TAG',
        4: '/api/manager/user/getEditForm?userId={0}',
        5: '/api/manager/user/getCreateForm',
        6: '/api/manager/enum/getCreateForm?type={0}',
        7: '/api/manager/enum/getUpdateForm?id={0}',
        8: '/api/manager/material/getDataStatisticCreateForm',
        9: '/api/manager/xhs/note/getCreateForm',
        10: '/api/manager/enum/getCreateForm?type=SCOPE',
        11: '/api/manager/xhs/author/getCreateForm',
        12: '/api/manager/enum/getCreateForm?type={0}&sort=true',
        13: '/api/manager/site/page/getCreateForm?refId={0}',
        14: '/api/manager/site/page/getUpdateForm?id={0}',
        15: '/api/manager/site/banner/getBannerCreateForm',
        16: '/api/manager/site/banner/getBannerEditForm?id={0}',
        17: '/api/manager/site/page/getCopyToForm?pageId={0}',
        18: '/api/manager/site/school/getCreateForm?siteId={0}',
        19: '/api/manager/site/school/getEditForm?schoolId={0}',
        20: '/api/manager/site/hot/getCreateForm?pageId={0}',
        21: '/api/manager/site/hot/getEditForm?id={0}',
        22: '/api/manager/site/countdown/getCreateForm',
        23: '/api/manager/site/countdown/getEditForm?id={0}',
        24: '/api/manager/enum/getCreateForm?type={0}&sort=true',
        25: '/api/manager/enum/getKeywordReplaceForm?fromId={0}',
        26: '/api/manager/net/getCreateForm',
    },
    simpleBtn: {
        1: {
            dialogId: 1,
            submitUrl: '/api/manager/enum/create?t=0',
        },
        2: {
            dialogId: 2,
            submitUrl: '/api/manager/enum/create?t=1',
        },
        3: {
            dialogId: 3,
            submitUrl: '/api/manager/enum/create?t=3',
        },
        4: {
            dialogId: 8,
            submitUrl: '/api/manager/material/addDataStatistic',
        },
        5: {
            dialogId: 10,
            submitUrl: '/api/manager/enum/create?t=2',
        },
        6: {
            dialogId: 15,
            submitUrl: '/api/manager/site/banner/createBanner',
        },
        7: {
            dialogId: 17,
            submitUrl: '/api/manager/site/page/copyTo',
        },
        8: {
            dialogId: 17,
            submitUrl: '/api/manager/site/page/batchCopyTo',
        },
        9: {
            dialogId: 20,
            submitUrl: '/api/manager/site/hot/create',
        },
        10: {
            dialogId: 22,
            submitUrl: '/api/manager/site/countdown/create',
        },
        11: {
            dialogId: 23,
            submitUrl: '/api/manager/site/countdown/create',
        },
        12: {
            dialogId: 24,
            submitUrl: '/api/manager/enum/create',
        },
        13: {
            dialogId: 7,
            submitUrl: '/api/manager/enum/update',
        },
        14: {
            dialogId: 25,
            submitUrl: '/api/manager/enum/replaceKeyword',
        },
        15: {
            dialogId: 26,
            submitUrl: '/api/manager/net/create',
        },
    },
    table: {
        1: {
            list: '/api/manager/user/list',
            listMethod: 'post',
            queryForm: 1,
            createDialog: 5,
            create: '/api/manager/user/create',
            updateDialog: 4,
            update: '/api/manager/user/update',
            updateKey: 'id',
            delete: '/api/manager/user/delete',
            deleteKey: 'id',
        },
        2: {
            queryForm: 8,
            list: '/api/manager/enum/list',
            updateDialog: 7,
            update: '/api/manager/enum/update',
            updateKey: 'id',
            delete: '/api/manager/enum/delete',
            deleteKey: 'id',
        },
        3: {
            queryForm: 2,
            list: '/api/manager/xhs/author/list',
            createDialog: 11,
            create: '/api/manager/xhs/author/importFromUrl',
        },
        4: {
            queryForm: 3,
            list: '/api/manager/xhs/note/list',
            createDialog: 9,
            create: '/api/manager/xhs/note/importFromUrl',
            listMethod: 'post',
        },
        5: {
            queryForm: 4,
            listMethod: 'post',
            list: '/api/manager/site/page/list',
            createDialog: 13,
            createKey: 'siteId',
            create: '/api/manager/site/page/create',
            updateDialog: 14,
            update: '/api/manager/site/page/update',
            updateKey: 'id',
            delete: '/api/manager/site/page/delete',
            deleteKey: 'id',
        },
        6: {
            queryForm: 5,
            listMethod: 'post',
            list: '/api/manager/site/spy/list',
        },
        7: {
            list: '/api/manager/site/banner/bannerList',
            delete: '/api/manager/site/banner/deleteBanner',
            deleteKey: 'id',
            updateDialog: 16,
            update: '/api/manager/site/banner/updateBanner',
            updateKey: 'id',
        },
        8: {
            list: '/api/manager/site/page/pageStatisticList',
        },
        9: {
            queryForm: 4,
            listMethod: 'post',
            list: '/api/manager/site/page/list',
            createDialog: 13,
            createKey: 'siteId',
            create: '/api/manager/site/page/create',
            updateDialog: 14,
            update: '/api/manager/site/page/update',
            updateKey: 'id',
            delete: '/api/manager/site/page/delete',
            deleteKey: 'id',
        },
        10: {
            queryForm: 7,
            listMethod: 'post',
            list: '/api/manager/site/school/list',
            createDialog: 18,
            createKey: 'siteId',
            create: '/api/manager/site/school/createOrUpdate',
            updateDialog: 19,
            update: '/api/manager/site/school/createOrUpdate',
            updateKey: 'id',
            delete: '/api/manager/site/school/delete',
            deleteKey: 'id',
        },
        11: {
            list: '/api/manager/site/hot/list',
            updateDialog: 21,
            update: '/api/manager/site/hot/update',
            updateKey: 'id',
            delete: '/api/manager/site/hot/delete',
            deleteKey: 'id',
        },
        12: {
            queryForm: 4,
            listMethod: 'post',
            list: '/api/manager/site/page/selectTable',
        },
        13: {
            listMethod: 'post',
            list: '/api/manager/site/page/list4view',
        },
    }

}

export default base;
